module.exports = __webpack_public_path__ + "media/shared/high-five@3x-00b892ca.png";